<template>
  <div class="tw-flex tw-border-b tw-text-xs tw-font-semibold">
    <c-timeline-period-switch
      v-model="model"
      switch-direction="previous"
      switch-type="year"
      :disable="!canGoPrevious"
    />

    <div
      class="tw-flex tw-flex-1 tw-select-none tw-items-center tw-justify-center tw-overflow-hidden"
    >
      <span class="tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap">
        {{ selectedSchoolYear }}
      </span>
    </div>

    <c-timeline-period-switch
      v-model="model"
      switch-direction="next"
      switch-type="year"
      :disable="!canGoNext"
    />
  </div>
</template>

<script setup>
import CTimelinePeriodSwitch from "shared/components/wrappers/timeline-calendar/CTimelinePeriodSwitch.vue";
import { getCurrentSchoolYear } from "composables/useHelpers";
import { computed } from "vue";

const model = defineModel({
  type: Object,
  required: true,
  default: () => ({}),
});

const props = defineProps({
  switchFuture: {
    type: Boolean,
    default: true,
  },
  switchPast: {
    type: Boolean,
    default: true,
  },
});

const canGoNext = computed(() => {
  const { switchFuture } = props;

  if (switchFuture) {
    return true;
  }

  if (!model.value.schoolYears) {
    return false;
  }

  const currentSchoolYear = getCurrentSchoolYear().replace("/", "-");
  const currentSchoolYearIndex = model.value.schoolYears.findIndex(
    (schoolYear) => schoolYear.label === currentSchoolYear,
  );
  const selectedSchoolYearIndex = model.value.schoolYears.findIndex(
    (schoolYear) => schoolYear.label === selectedSchoolYear.value,
  );

  if (currentSchoolYearIndex === -1 || selectedSchoolYearIndex === -1) {
    return false;
  }

  return selectedSchoolYearIndex < currentSchoolYearIndex;
});

const canGoPrevious = computed(() => {
  // Currently we don't use this functionality, so we will not implement it for now
  const { switchPast } = props;

  if (switchPast) {
    return true;
  }
});

const selectedSchoolYear = computed(
  () =>
    model.value.selectedSchoolYear.value?.label || "Schooljaar niet gevonden",
);
</script>

<style lang="scss" scoped></style>
